<!-- Header -->
<div *ngIf="headerType === 'title'; else subtitle">
  <hb-text-title class="headerText float-left" [text]="headerText"></hb-text-title>
</div>
<ng-template #subtitle>
  <hb-text-subtitle class="headerText float-left" [text]="headerText"></hb-text-subtitle>
</ng-template>

<!-- Button -->
<ng-content select="[button]"></ng-content>
